import { render, staticRenderFns } from "./editNews.vue?vue&type=template&id=c32b67f4"
import script from "./editNews.vue?vue&type=script&lang=js"
export * from "./editNews.vue?vue&type=script&lang=js"
import style0 from "./editNews.vue?vue&type=style&index=0&id=c32b67f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports